export default {
  path: '/content',
  name: 'content',
  meta: { title: '内容GEO' },
  children: [
    {
      path: '/content/:type',
      name: 'contentIndex',
      component: () => import('@/views/content/index.vue'),
      meta: { title: '内容GEO', subTitle: 'AI 适配优化，让内容被优先推荐', key: 'content' },
    },
  ],
};
